import React, { useContext } from 'react'

import styled from 'styled-components';
import { DataContext } from '../contexts/DataContext';

export default function Footer() {
  const { contacts } = useContext(DataContext);
  const year = new Date().getFullYear();

  return (
    <FOOTER>
      <div className="left">
        {contacts && contacts.map(contact => (
          <a key={contact.id} href={contact.url} target='_blank' rel='noreferrer'>{contact.title}</a>
        ))}
      </div>
      <div className="right">
        <span>химеры {year}</span>
      </div>
    </FOOTER>
  )
}


const FOOTER = styled.footer`
  margin-top: auto;
  padding: 90px 0 100px 0;

  display: flex;
  justify-content: center;
  align-items: center;

  & .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
  }

  & a, & span {
    font-size: 1.125rem;
    font-weight: 700;
    font-family: var(--primary-font);
    color: black;
    text-decoration: none;
  }

  & a:hover {
    text-decoration: underline;
    pointer: cursor;
  }

  & .right {
    display: none;
  }

  @media (min-width: 768px) {
    padding: 110px var(--main-side-padding) 60px var(--main-side-padding);

    justify-content: space-between;

    & .left {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      gap: 2.25rem;
    }

    & .right {
      display: block;
    }
  }
`;